import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class OrphanFilesPane extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
    this.deleting = false;
    this.error = '';
    this.notice = '';
    this.items = [];
    this.selected = new Set();
    this.limit = 100;
    this.nextOffset = 0;
    this.totalCandidates = null;
    this.totalScanned = 0;
    this.finished = false;
    this.started = false;
    this.lightboxId = null;
    this.lightboxKeyHandler = e => {
      if (this.lightboxId === null) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        this.closeLightbox();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.moveLightbox(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.moveLightbox(1);
      }
    };
    document.addEventListener('keydown', this.lightboxKeyHandler);
  }
  onremove(vnode) {
    document.removeEventListener('keydown', this.lightboxKeyHandler);
    super.onremove(vnode);
  }
  api(path) {
    return String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '') + path;
  }
  async analyse(reset) {
    if (reset === void 0) {
      reset = false;
    }
    if (this.loading) return;
    if (reset) {
      this.items = [];
      this.selected = new Set();
      this.nextOffset = 0;
      this.totalCandidates = null;
      this.totalScanned = 0;
      this.finished = false;
    }
    this.loading = true;
    this.error = '';
    this.notice = '';
    this.started = true;
    const offset = this.nextOffset || 0;
    try {
      const data = await app.request({
        method: 'GET',
        url: this.api('/val/moderation/orphan-files') + '?offset=' + encodeURIComponent(offset) + '&limit=' + encodeURIComponent(this.limit)
      });
      const incoming = Array.isArray(data.orphans) ? data.orphans : [];
      const byId = new Map(this.items.map(item => [Number(item.id), item]));
      incoming.forEach(item => {
        byId.set(Number(item.id), item);
      });
      this.items = Array.from(byId.values());
      this.totalCandidates = Number(data.total_candidates || 0);
      this.totalScanned += Number(data.scanned || 0);
      this.nextOffset = data.next_offset === null || data.next_offset === undefined ? null : Number(data.next_offset);
      this.finished = !!data.finished;
      if (this.finished && this.items.length === 0) {
        this.notice = 'Aucun fichier orphelin détecté.';
      }
    } catch (e) {
      this.error = e?.response?.error || 'Impossible d’analyser les fichiers.';
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  toggle(id, checked) {
    id = Number(id);
    if (checked) {
      this.selected.add(id);
    } else {
      this.selected.delete(id);
    }
  }
  selectAll() {
    this.items.forEach(item => this.selected.add(Number(item.id)));
  }
  clearSelection() {
    this.selected.clear();
  }
  async deleteSelected() {
    if (this.deleting || this.selected.size === 0) return;
    const ids = Array.from(this.selected);
    if (!window.confirm('Supprimer définitivement ' + ids.length + ' fichier(s) orphelin(s) ?\n\n' + 'Le fichier physique et son enregistrement FoF Upload seront supprimés.')) {
      return;
    }
    this.deleting = true;
    this.error = '';
    this.notice = '';
    try {
      const data = await app.request({
        method: 'POST',
        url: this.api('/val/moderation/orphan-files/delete'),
        body: {
          ids
        }
      });
      const deleted = new Set((data.deleted || []).map(id => Number(id)));
      this.items = this.items.filter(item => !deleted.has(Number(item.id)));
      deleted.forEach(id => this.selected.delete(id));
      const skipped = Array.isArray(data.skipped) ? data.skipped : [];
      this.notice = deleted.size + ' fichier(s) supprimé(s).' + (skipped.length ? ' ' + skipped.length + ' fichier(s) non supprimé(s) après revérification.' : '');
    } catch (e) {
      this.error = e?.response?.error || 'Impossible de supprimer les fichiers sélectionnés.';
    } finally {
      this.deleting = false;
      m.redraw();
    }
  }
  formatDate(value) {
    if (!value) return '—';
    try {
      return new Intl.DateTimeFormat('fr-FR', {
        dateStyle: 'short',
        timeStyle: 'short'
      }).format(new Date(value));
    } catch (e) {
      return value;
    }
  }
  imageItems() {
    return this.items.filter(item => item.is_image && (item.url || item.thumbnail));
  }
  openLightbox(id) {
    this.lightboxId = Number(id);
  }
  closeLightbox() {
    this.lightboxId = null;
  }
  moveLightbox(delta) {
    const images = this.imageItems();
    if (!images.length || this.lightboxId === null) return;
    let index = images.findIndex(item => Number(item.id) === Number(this.lightboxId));
    if (index < 0) index = 0;
    index = (index + delta + images.length) % images.length;
    this.lightboxId = Number(images[index].id);
  }
  lightboxView() {
    if (this.lightboxId === null) return null;
    const images = this.imageItems();
    const index = images.findIndex(item => Number(item.id) === Number(this.lightboxId));
    if (index < 0) {
      this.lightboxId = null;
      return null;
    }
    const item = images[index];
    const src = item.url || item.thumbnail;
    return m('.ValOrphanLightbox', {
      onclick: () => this.closeLightbox()
    }, [m('.ValOrphanLightbox-dialog', {
      onclick: e => e.stopPropagation()
    }, [m('button.ValOrphanLightbox-close', {
      type: 'button',
      title: 'Fermer',
      'aria-label': 'Fermer',
      onclick: () => this.closeLightbox()
    }, [m('i.fas.fa-times')]), images.length > 1 ? m('button.ValOrphanLightbox-nav.ValOrphanLightbox-nav--prev', {
      type: 'button',
      title: 'Image précédente',
      'aria-label': 'Image précédente',
      onclick: () => this.moveLightbox(-1)
    }, [m('i.fas.fa-chevron-left')]) : null, m('img.ValOrphanLightbox-image', {
      src,
      alt: item.name || ''
    }), images.length > 1 ? m('button.ValOrphanLightbox-nav.ValOrphanLightbox-nav--next', {
      type: 'button',
      title: 'Image suivante',
      'aria-label': 'Image suivante',
      onclick: () => this.moveLightbox(1)
    }, [m('i.fas.fa-chevron-right')]) : null, m('.ValOrphanLightbox-caption', [m('strong', item.name || 'Fichier #' + item.id), m('span', index + 1 + ' / ' + images.length)])])]);
  }
  preview(item) {
    if (item.is_image && item.thumbnail) {
      return m('button.ValOrphanFiles-thumbButton', {
        type: 'button',
        title: 'Agrandir l’image',
        onclick: () => this.openLightbox(item.id)
      }, [m('img.ValOrphanFiles-thumb', {
        src: item.thumbnail,
        alt: '',
        loading: 'lazy'
      })]);
    }
    return m('.ValOrphanFiles-fileIcon', [m('i.fas.fa-paperclip')]);
  }
  view() {
    return m('.ValModerationPane.ValOrphanFiles', [m('h2', 'Fichiers orphelins'), m('p.helpText', 'Analyse les fichiers FoF Upload sans message associé et âgés de plus de 24 h. ' + 'Chaque candidat est aussi recherché par URL et UUID dans tous les messages avant d’être proposé.'), m('.ValOrphanFiles-toolbar', [m('button.Button.Button--primary', {
      type: 'button',
      disabled: this.loading || this.deleting,
      onclick: () => this.analyse(true)
    }, this.loading && this.totalScanned === 0 ? 'Analyse…' : 'Analyser'), this.started && !this.finished ? m('button.Button', {
      type: 'button',
      disabled: this.loading || this.deleting,
      onclick: () => this.analyse(false)
    }, this.loading ? 'Analyse…' : 'Analyser les suivants') : null, this.items.length ? m('button.Button', {
      type: 'button',
      disabled: this.deleting,
      onclick: () => this.selectAll()
    }, 'Tout sélectionner') : null, this.selected.size ? m('button.Button', {
      type: 'button',
      disabled: this.deleting,
      onclick: () => this.clearSelection()
    }, 'Tout désélectionner') : null, this.selected.size ? m('button.Button.Button--danger', {
      type: 'button',
      disabled: this.loading || this.deleting,
      onclick: () => this.deleteSelected()
    }, this.deleting ? 'Suppression…' : 'Supprimer la sélection (' + this.selected.size + ')') : null]), this.started && this.totalCandidates !== null ? m('.ValOrphanFiles-summary', [m('strong', this.items.length + ' orphelin(s) détecté(s)'), ' — ', this.totalScanned + ' candidat(s) analysé(s) sur ' + this.totalCandidates, this.finished ? ' — analyse terminée' : '']) : null, this.error ? m('.Alert.Alert--error', this.error) : null, this.notice ? m('.Alert.Alert--success', this.notice) : null, this.items.length ? m('.ValModerationTableWrap', [m('table.ValModerationTable.ValOrphanFiles-table', [m('thead', [m('tr', [m('th.ValOrphanFiles-check'), m('th.ValOrphanFiles-preview', 'Aperçu'), m('th', 'Fichier'), m('th', 'Type'), m('th', 'Taille'), m('th', 'Auteur'), m('th', 'Date')])]), m('tbody', this.items.map(item => m('tr', {
      key: item.id
    }, [m('td.ValOrphanFiles-check', [m('input', {
      type: 'checkbox',
      checked: this.selected.has(Number(item.id)),
      onchange: e => this.toggle(item.id, e.target.checked)
    })]), m('td.ValOrphanFiles-preview', this.preview(item)), m('td', [m('.ValOrphanFiles-name', item.name || 'Fichier #' + item.id), m('.ValOrphanFiles-id', '#' + item.id), item.url ? m('a.ValOrphanFiles-url', {
      href: item.url,
      target: '_blank',
      rel: 'noopener'
    }, item.url) : null]), m('td', item.type || '—'), m('td', item.human_size || '—'), m('td', item.actor || (item.actor_id ? '#' + item.actor_id : '—')), m('td', this.formatDate(item.created_at))])))])]) : this.started && !this.loading ? m('.ValOrphanFiles-empty', this.finished ? 'Aucun fichier orphelin dans les éléments analysés.' : 'Aucun orphelin dans ce lot.') : null, this.lightboxView()]);
  }
}